
import { $api } from "../../../services/request.config";
// thunks/LocalTrips/localTripsThunks.js

import {
    getLocalTripsListAction,
    getLocalTripDetailAction,
    createLocalTripAction,
    getLocalTripReasonsAction,
    getLocalTripDecisionsAction,
    cancelLocalTripAction,
    approveLocalTripAction,
    getErrorLocalTripAction,
    clearLocalTripDetailAction,
    clearCreateLocalTripAction,
    clearCancelLocalTripAction,
    clearApproveLocalTripAction,
    clearErrorLocalTripAction, deleteLocalTripAction,
} from "../LocalTrips.action";
import { setCurrentDocumentAction } from "../../Requests/CurrentRequest/setCurrentDocument.action";
import { getUserRequestsThunkAction } from "../../Requests/GetUserRequests/thunk/getUserRequests.thunk.action";
import { clearCurrentRequestAction } from "../../Requests/CurrentRequest/clearCurrentRequest.action";
import countly from "../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../analytics/events";

import moment from "moment/moment";

// Получить список командировок

// export const getLocalTripsListThunk = ({role, setStatusModal, statusModal}) => async (dispatch) => {
//     try {
//         // dispatch(clearErrorLocalTripAction());
//         const response = await $api.get("/v1/localtrips", {
//             params: { role },
//         } );
//
//         console.log("ROLR", response );
//         if (response.status === 200) {
//             dispatch(getLocalTripsListAction(response.data));
//         }
//     } catch (error) {
//         setStatusModal({
//             ...statusModal,
//             status: true,
//             message:  "Произошла ошибка при загрузке данных",
//         });
//         // dispatch(getErrorLocalTripAction(error.response?.data || error.message));
//     }
// };
//

export const getLocalTripsListThunk = ({
                                           role = "initiator",
                                           page = 1,
                                           pageSize = 20,
                                           setStatusModal,
                                           statusModal,
                                       }) => async (dispatch) => {
    try {
        const response = await $api.get("/v1.0/localtrips", {
            params: {
                role,
                page,
                pageSize: Math.min(pageSize, 100),
            },
        });

        if (response.status === 200) {
            // Бэкенд возвращает данные в формате { items: [...], pagination: {...} }
            // где pagination содержит page, pageSize, totalItems, totalPages
            dispatch(getLocalTripsListAction({
                items: response.data.items || [],
                pagination: response.data.pagination || {
                    page: 1,
                    pageSize: 20,
                    totalItems: 0,
                    totalPages: 1,
                },
            }));
        }
    } catch (error) {
        console.error("Error fetching local trips:", error);

        if (setStatusModal) {
            setStatusModal({
                ...statusModal,
                status: true,
                message: "Произошла ошибка при загрузке данных",
            });
        }

        dispatch(getErrorLocalTripAction(error.response?.data || error.message));
    }
};

// Получить детали командировки по ID
export const getLocalTripDetailThunk = (id, props) => async (dispatch) => {
    try {
        dispatch(clearLocalTripDetailAction());
        dispatch(clearErrorLocalTripAction());

        const response = await $api.get(`/v1.0/localtrips/${id}`);
        console.log("ROLR", response );
        if (response.status === 200) {
            dispatch(getLocalTripDetailAction(response.data));
            const request = {};
            request["Наименование"] = "Местная командировка";
            request["причина отсутствия"] = response.data.reason.displayName;
            request["статус"] = response.data.status.displayName;
            request["дата и время начала отсутствия"] = moment(response.data.startsAt).format("DD.MM.YYYY HH:mm");
            request["дата и время возвращения на работу"] = moment(response.data.endsAt).format("DD.MM.YYYY HH:mm");
            request["комментарий"] = response.data.comment ? response.data.comment : "...";
            request["комментарий руководителя"] = response.data.rejectionComment ? response.data.rejectionComment : "...";
            dispatch(setCurrentDocumentAction({ currentRequestCard: request,
                currentRequest:
                    {... response.data,

                        initiatorFullname: response.data.initiator.fullName } }));
            dispatch(getUserRequestsThunkAction());
        } else {
            dispatch(clearCurrentRequestAction());
        }
    } catch (error) {
        props.setDescription && props.setDescription("Не удалось загрузить информацию по заявке. Пожалуйста, повторите попытку позже.");
    }
};

// Создать командировку
export const createLocalTripThunk = (tripData, props) => async (dispatch) => {
    try {
        dispatch(clearCreateLocalTripAction());
        dispatch(clearErrorLocalTripAction());

        const response = await $api.post("v1.0/localtrips", tripData);

        if (response.status === 200 || response.status === 201) {
            countly.event(EVENT_NAMES.LOCAL_TRIP_CREATED, { pid: localStorage.getItem("pid") });
           props.setIsLoading(false);
            dispatch(createLocalTripAction(response.data));
            return response.data;
        }
    } catch (error) {
        console.log(error);
        props.setIsLoading(false);
        dispatch(getErrorLocalTripAction(error.response?.data?.detail || error.message));
        // throw error;
    }
};

// Получить причины отсутствия
export const getLocalTripReasonsThunk = () => async (dispatch) => {
    try {
        dispatch(clearErrorLocalTripAction());
        const response = await $api.get("/v1.0/localtrips/reasons");

        if (response.status === 200) {
            dispatch(getLocalTripReasonsAction(response.data));
        }
    } catch (error) {
        dispatch(getErrorLocalTripAction(error.response?.data || error.message));
    }
};

// Получить решения руководителя
export const getLocalTripDecisionsThunk = () => async (dispatch) => {
    try {
        dispatch(clearErrorLocalTripAction());
        const response = await $api.get("api/v1/localtrips/decisions");

        if (response.status === 200) {
            dispatch(getLocalTripDecisionsAction(response.data));
        }
    } catch (error) {
        dispatch(getErrorLocalTripAction(error.response?.data || error.message));
    }
};

// Отменить командировку


export const cancelLocalTripThunk = ({ id, statusModal, setStatusModal }) => async (dispatch) => {
    try {
        const response = await $api.post(`/v1.0/localtrips/${id}/cancel`);

        if (response.status === 200) {
            countly.event(EVENT_NAMES.LOCAL_TRIP_CANCELLED, { pid: localStorage.getItem("pid") });
            dispatch(getLocalTripsListThunk({ role: "initiator", setStatusModal: setStatusModal, statusModal: statusModal }));
            setStatusModal({
                status: false,
                loading: false,
                message: "",
                delete: false,
                trip: null,
                id: null,
            });
        }
    } catch (error) {
        setStatusModal({ ...statusModal, loading: false });

        if (error.response?.status === 404) {
            setStatusModal({
                delete: false,
                status: true,
                loading: false,
                message: "Командировка не найдена",
                trip: null,
                id: null,
            });
        } else if (error.response?.status === 403) {
            setStatusModal({
                delete: false,
                status: true,
                loading: false,
                message: `${error.response.data.detail || "Нет доступа к командировке"}`,
                trip: null,
                id: null,
            });
        } else if (error.response?.status === 409) {
            setStatusModal({
                delete: false,
                status: true,
                loading: false,
                message: "Командировка не может быть отменена (уже активна или завершена)",
                trip: null,
                id: null,
            });
        } else {
            setStatusModal({
                delete: false,
                status: true,
                loading: false,
                message: "Ошибка при отмене командировки",
                trip: null,
                id: null,
            });
        }
    }
};

// Согласовать/отклонить командировку
export const approveLocalTripThunk = (id, decisionData, props) => async (dispatch) => {
    try {
        props.setState(true);
        dispatch(clearApproveLocalTripAction());
        dispatch(clearErrorLocalTripAction());

        const response = await $api.post(`/v1.0/localtrips/${id}/approve`, decisionData);

        if (response.status === 200) {
            props.setState(false);
            props.setDescription( decisionData.decision === "APPROVED" ? "Командировка успешно согласована" : "Командировка отклонена");
            dispatch(approveLocalTripAction(response.data));
            return response.data;
        }
    } catch (error) {
        props.setState(false);
        props.setDescription(error.response?.data.detail || "Произошла ошибка, повторите попытку позже");
        // throw error;
    }
};

